<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="rounded-lg p-12 mv-16" :class="noticeMessage.class" data-testid="notice-message">
    <BlTextAv variation="caption-12" data-testid="notice-text" v-html="noticeMessage.text" />
  </div>
</template>

<script>
import {BlTextAv} from '@bukalapak/bazaar-mweb-latest';
import {money} from '@bukalapak/toolbox-helper/number-helper';

export default {
  name: 'GamificationNoticeMessage',
  components: {
    BlTextAv,
  },
  filters: {money},
  props: {
    missions: {
      type: Array,
      required: true,
    },
  },
  computed: {
    isAllEmptyQuota() {
      return this.missions?.every((mission) => mission.used_quota >= mission.quota);
    },
    isAllMissionCompleted() {
      return this.missions?.every((mission) => mission.milestone?.progress >= mission.goal_threshold);
    },
    onGoingMissionIndex() {
      const index = this.missions?.findIndex((mission) => mission.milestone === null || mission.milestone.state === 'in_progress');
      return index === -1 ? 0 : index;
    },
    onGoingMission() {
      return this.missions?.[this.onGoingMissionIndex];
    },
    gotRewardMissionIndex() {
      return this.missions?.findIndex(
        (mission) => mission.milestone?.state === 'completed' && mission.milestone.reward_redemption === null
      );
    },
    gotRewardMission() {
      return this.missions[this.gotRewardMissionIndex];
    },
    claimableMission() {
      return this.missions?.find(
        (mission) =>
          mission.milestone?.state === 'completed' && mission.milestone.reward_redemption === null && mission.used_quota < mission.quota
      );
    },
    remainingThreshold() {
      return this.onGoingMission.goal_threshold - (this.onGoingMission.milestone?.progress || 0);
    },
    availableMissionIndex() {
      return this.missions?.findIndex((mission) => mission.used_quota < mission.quota);
    },
    emptyQuotaMissionsCopy() {
      const formatter = new Intl.ListFormat('id', {
        style: 'long',
        type: 'conjunction',
      });

      const emptyMissions = this.missions
        ?.map((mission, index) => (mission.used_quota >= mission.quota && mission.milestone?.state !== 'completed' ? index + 1 : null))
        .filter(Boolean)
        .map((index) => `ke-${index}`);

      return formatter.format(emptyMissions);
    },
    noticeMessage() {
      if (this.isAllMissionCompleted) {
        return {
          class: 'bg-notice-blue',
          text: 'Kamu sukses selesaikan semua misi, mantap 👑',
        };
      }
      if (this.isAllEmptyQuota) {
        return {
          class: 'bg-notice-red',
          text: 'Sayang sekali, kuota hadiah semua misi habis 😢<br/>Coba lagi di kesempatan berikutnya, ya.',
        };
      } else if (this.gotRewardMission) {
        if (this.gotRewardMission.used_quota < this.gotRewardMission.quota) {
          return {
            class: 'bg-notice-blue',
            text: `<b>Keren 🙌 kamu dapet saldo ${money(
              this.gotRewardMission.reward
            )}.</b> Ambil hadiah kamu dan lanjut kejar misi berikutnya buat dapetin ${money(this.onGoingMission?.reward)}`,
          };
        } else if (this.claimableMission) {
          return {
            class: 'bg-notice-blue',
            text: `<b>Keren 🙌 kamu dapet saldo ${money(
              this.claimableMission.reward
            )}.</b> Ambil hadiah kamu dan lanjut kejar misi berikutnya buat dapetin ${money(this.onGoingMission?.reward)}`,
          };
        } else {
          return {
            class: 'bg-notice-red',
            text: `Kuota hadiah misi ${this.emptyQuotaMissionsCopy} habis 😢<br/>Yuk, lebih gercep kejar misi ke-${
              this.availableMissionIndex + 1
            }`,
          };
        }
      }
      if (this.onGoingMission.used_quota >= this.onGoingMission.quota) {
        return {
          class: 'bg-notice-red',
          text: `Kuota hadiah misi ${this.emptyQuotaMissionsCopy} habis 😢<br/>Yuk, lebih gercep kejar misi ke-${
            this.availableMissionIndex + 1
          }`,
        };
      }
      return {
        class: 'bg-notice-blue',
        text:
          this.onGoingMission.goal_type === 'total_class'
            ? `Yuk selesaikan ${this.remainingThreshold} kelas buat dapetin ${money(this.onGoingMission.reward)}`
            : `Yuk, selesaikan 1 kelas atau lebih dengan total beli ${money(this.remainingThreshold)} buat dapetin ${money(
                this.onGoingMission.reward
              )}`,
      };
    },
  },
};
</script>
<style scoped>
.bg-notice-blue {
  background: #ebf2fa;
}
.bg-notice-red {
  background: #fce6ed;
}
</style>
